(function(){
  document.querySelectorAll('[data-ok3d]').forEach(function(box){
    var cv = document.createElement('canvas'); box.appendChild(cv); var ctx = cv.getContext('2d');
    var img = new Image(), rows = null;
    var BOX = {x:.2895, y:.25, w:.421, h:.53}, THICK = .05, FACE = '#0B0612', SIDE = '#2b2633';
    var bb = (box.getAttribute('data-box') || '').split(',').map(parseFloat);
    if(bb.length === 4 && bb.every(function(n){ return n >= 0 && n <= 1; })){ BOX = {x:bb[0], y:bb[1], w:bb[2], h:bb[3]}; }
    function build(){
      if(!img.naturalWidth) return;
      var W = Math.max(2, Math.round(BOX.w * cv.width * 2)), H = Math.max(2, Math.round(BOX.h * cv.height * 2));
      var t = document.createElement('canvas'); t.width = W; t.height = H; var x = t.getContext('2d');
      x.imageSmoothingQuality = 'high'; x.drawImage(img, 0, 0, W, H);
      var p; try { p = x.getImageData(0, 0, W, H).data; } catch(e){ return; }
      var out = [], y, i, on, start, r;
      for(y = 0; y < H; y++){
        r = []; on = false; start = 0;
        for(i = 0; i < W; i++){
          var a = p[(y * W + i) * 4 + 3] >= 128;
          if(a && !on){ on = true; start = i; }
          if(!a && on){ on = false; r.push(start / W - .5, i / W - .5); }
        }
        if(on){ r.push(start / W - .5, .5); }
        out.push(r);
      }
      rows = out;
    }
    img.crossOrigin = 'anonymous'; img.onload = build; img.src = box.getAttribute('data-slide');
    var st = {angle:0, vel:0, auto:0.006}, drag = false, lastX = 0, lastT = 0;
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches){ st.auto = 0; }
    function size(){ var r = box.getBoundingClientRect(), d = Math.min(window.devicePixelRatio || 1, 2); cv.width = Math.round(r.width * d); cv.height = Math.round(r.height * d); }
    size(); window.addEventListener('resize', function(){ size(); build(); });
    function frame(){
      if(!drag){ st.vel += (st.auto - st.vel) * 0.03; st.angle += st.vel; }
      if(rows){
        var S = cv.width, w = BOX.w * S, h = BOX.h * S, cx = (BOX.x + BOX.w/2) * S, cy = (BOX.y + BOX.h/2) * S;
        var c = Math.cos(st.angle), s = Math.sin(st.angle), T = THICK * S / 2, P = S * 3.2;
        var n = rows.length, dy = h / n, zVis = c >= 0 ? T : -T, Ts = Math.abs(T * s), CH = Math.max(6, S / 40);
        var y, r, j, y0, a, b, k, x0, x1, u, v, m, pass, tmp;
        ctx.clearRect(0, 0, S, S);
        for(pass = 0; pass < 2; pass++){
          ctx.fillStyle = pass ? FACE : SIDE;
          for(y = 0; y < n; y++){
            r = rows[y]; if(!r.length) continue;
            y0 = y * dy - h/2;
            for(j = 0; j < r.length; j += 2){
              a = r[j] * w; b = r[j+1] * w;
              if(!pass){
                k = P / (P + a * s); ctx.fillRect(cx + (a * c - Ts) * k, cy + y0 * k - 0.3, 2 * Ts * k, dy * k + 0.6);
                k = P / (P + b * s); ctx.fillRect(cx + (b * c - Ts) * k, cy + y0 * k - 0.3, 2 * Ts * k, dy * k + 0.6);
              }
              if(pass) for(u = a; u < b; u += CH){
                v = Math.min(b, u + CH); m = (u + v) / 2;
                k = P / (P - (-m * s + zVis * c));
                x0 = (u * c + zVis * s) * k; x1 = (v * c + zVis * s) * k;
                if(x0 > x1){ tmp = x0; x0 = x1; x1 = tmp; }
                ctx.fillRect(cx + x0 - 0.25, cy + y0 * k - 0.3, x1 - x0 + 0.5, dy * k + 0.6);
              }
            }
          }
        }
      }
      requestAnimationFrame(frame);
    }
    box.addEventListener('pointerdown', function(e){ drag = true; lastX = e.clientX; lastT = performance.now(); st.vel = 0; box.classList.add('is-drag'); box.setPointerCapture(e.pointerId); });
    box.addEventListener('pointermove', function(e){ if(!drag) return; var dx = e.clientX - lastX, now = performance.now(), dt = Math.max(now - lastT, 1); st.angle += dx * 0.011; st.vel = (dx * 0.011) / dt * 16; lastX = e.clientX; lastT = now; });
    function end(){ drag = false; box.classList.remove('is-drag'); }
    box.addEventListener('pointerup', end); box.addEventListener('pointercancel', end);
    frame();
  });
})();
